import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import ReactTable from 'react-table';
import WidgetGrid from '../../../components/widgets/WidgetGrid';
import BigBreadcrumbs from '../../../components/navigation/components/BigBreadcrumbs';
import Pagination from '../../../components/common/Pagination';
import ClinicActivityStats from '../components/ClinicActivityStats';
import IMCScorecard from '../components/IMCScorecard';
import ChartReviewQueueReport from '../components/ChartReviewQueueReport';
import { hostTitle } from '../../../config/ui';
import {
  requestDashboardInfo,
  requestChartReviewQueueReport,
} from '../../../store/dashboard/DashboardActions';
import { requestIMCMetrics } from '../../../store/imc/IMCActions';
import Mapp from '../components/Map';
import ClientInfo from '../components/ClientInfo';
import Moment from '../../../components/utils/Moment';
import {
  isSuperAdmin,
  isAdministrativeProvider,
  isSupervisingPhysician,
  isExternalStakeholder,
  isOrganizationalClient,
  isAdmin,
  isClinician,
  isClinicalStaff,
  isPhysiciansAssistant,
  isClinicalPharmacist,
  isMakoAdmin,
  isMakoUser
} from '../../../store/current-user/CurrentUserSelectors';
import { requestLocationsDashboard, requestDashboardMetricsCount } from '../../../store/location-manager/LocationManagerActions';
import NPSInput from '../../../components/nps-input/NPSInput';
import { hashHistory } from 'react-router';
import {
  requestUsersTypeahead,
  submitNPSForm,
} from '../../../store/users/UsersActions';
import DashboardMetrics from '../components/DashboardMetrics';
import GoogleMapReport from '../../reports-analytics/containers/GoogleMapReport';

const NPS_LOCALSTORAGE_NAME = 'telemetry.nps-form';

class Dashboard extends React.Component {
  constructor() {
    super();

    this.state = {
      showNPS: false,
      pageSize: 10,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],
      selectedOption: 2,
    };
    this.NPSFormSubmit = this.NPSFormSubmit.bind(this);
    this.getMetricsData = this.getMetricsData.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }


  componentDidMount() {
    const nps = localStorage.getItem(NPS_LOCALSTORAGE_NAME);
    if (nps) {
      const parsed = JSON.parse(nps);
      if (parsed) {
        const parsedDate = Date.parse(parsed.date);
        if (parsedDate) {
          const now = new Date();
          const diff = now - parsedDate;
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          if (days && days > 30) {
            this.setState({ showNPS: true });
          }
        }
        if (parsed.userID !== this.props.currentUser.data.id) {
          this.setState({ showNPS: true });
        }
      }
    } else {
      this.setState({ showNPS: true });
    }
    if (this.props.queryParams) {
          this.props.getDashboardInfo(this.props.queryParams);
          this.props.getIMCMetrics(this.props.queryParams);
          this.props.getChartReviewQueueReport(this.props.queryParams);
          this.props.getDashboardMetricsCount(this.props.queryParams);
    }
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getLocations({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.queryParams.tenantId,
        showValue: this.state.selectedOption,
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data ? response.payload.data.total : 0 / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.queryParams) !== JSON.stringify(this.props.queryParams)) {
      this.props.getDashboardInfo(this.props.queryParams);
      this.props.getIMCMetrics(this.props.queryParams);
      this.props.getChartReviewQueueReport(this.props.queryParams);
    }
  }

  getMetrics = params => {
    this.props.getIMCMetrics({ ...params, ...this.props.queryParams });
  };

  getMetricsData = () => {
    const arr = this.props.imc.metrics;
    const metrics = [
      ...arr
        .reduce((r, o) => {
          const key = o.providerName;

          const item =
            r.get(key) ||
            Object.assign({}, o, {
              totalVisitNotes: 0,
              withPotentialMSK: 0,
              withPotentialBreach: 0,
              withMSKFlagMarkedResolved: 0,
            });

          item.totalVisitNotes += o.totalVisitNotes;
          item.withPotentialMSK += o.withPotentialMSK;
          item.withPotentialBreach += o.withPotentialBreach;
          item.withMSKFlagMarkedResolved += o.withMSKFlagMarkedResolved;

          if (item.providerName === null) {
            item.providerName = 'Unassigned';
          }

          return r.set(key, item);
        }, new Map())
        .values(),
    ];
    return metrics;
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 20,
        order: '',
        search,
        filters,
        roles: ['Clinician', 'Physicians Assistant', 'Administrative Provider', 'Supervising Physician']
      })
      .then(result => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach(item => {
            if (item.masterId) {
              options.push({
                id: item.id,
                masterId: item.masterId,
                lastName: item.lastName,
                firstName: item.firstName,
              });
            }
          });
        }
        return options;
      });
  };

  formSubmit = vals => {
    if (vals.provider && vals.provider.id) {
      this.props.getChartReviewQueueReport({
        ...this.props.queryParams,
        userId: vals.provider.id,
      });
    } else {
      this.props.getChartReviewQueueReport({ ...this.props.queryParams });
    }
  };

  NPSFormSubmit(vals) {
    this.props
      .submitNPSForm(this.props.currentUser.data.id, vals)
      .then(response => {
        if (response.payload.data) {
          localStorage.setItem(
            NPS_LOCALSTORAGE_NAME,
            JSON.stringify({
              id: response.payload.data,
              date: Date(),
              userID: this.props.currentUser.data.id,
            }),
          );
          this.setState({ showNPS: false });
          toast.success('Thank you!');
        } else {
          toast.error('Something went wrong. Please try again later.');
        }
      });
  }

  detailLocation = (siteCode) => {
    hashHistory.push(`/location-manager/detail/${siteCode}`);
  };

  render() {
    const {
      isSuperAdmin,
      isAdministrativeProvider,
      isSupervisingPhysician,
      isOrganizationalClient,
      isExternalStakeholder,
      isAdmin,
      isClinicalStaff,
      isClinician,
      isPhysiciansAssistant,
      isMakoAdmin,
      isMakoUser
    } = this.props;

    const { currentUser: { data: userInfo }, locations, location } = this.props;

    const superMode = isSuperAdmin || isAdministrativeProvider || isSupervisingPhysician || isAdmin || isClinician || isPhysiciansAssistant;

    const externalMode = isExternalStakeholder || isOrganizationalClient || isMakoAdmin || isMakoUser;

    const selectedLocation = locations && locations.find(
      el => el.id === this.props.queryParams.practiceId,
    );
    const currentClinic = selectedLocation
      ? selectedLocation['name']
      : 'All Clinics';

    return (
      <div id="content">
        <Helmet title={`Mission Control – ${hostTitle()}`} />
        <div className="row">
          <BigBreadcrumbs
            items={['Mission Control', currentClinic]}
            className="col-xs-12 col-sm-7 col-md-7 col-lg-4"
          />
        </div>

        {/*{!externalMode && (*/}
        {/*  <Mapp />*/}
        {/*)}*/}

        <GoogleMapReport />
        {!externalMode && (
          <ReactTable
            ref={(instance) => {
              this.table = instance;
            }}
            page={this.state.page}
            manual
            pages={this.state.pages}
            loading={this.props.location.isLoading}
            data={location.data.list ? location.data.list : []}
            onFetchData={this.fetchData}
            defaultSorted={[
              {
                id: 'siteName',
              },
            ]}
            columns={[
              {
                Header: 'Location Name',
                id: 'siteName',
                accessor: 'siteName',
                Cell: (row) => (
                  <a
                    onClick={() =>
                      this.detailLocation(
                        row.original.clinicLocationID,
                      )
                    }
                  >
                    {row.original.siteName}
                  </a>
                ),
              },
              {
                Header: 'Address',
                Cell: (row) => (row.original.address1 + ' ' + ((row.original.address2 === null) ? '' : row.original.address2) + ' ' + row.original.city + ' ' + row.original.state + ' ' + row.original.zip)
              },
              {
                Header: 'Phone',
                id: 'phoneNumber',
                accessor: 'phoneNumber',
                width: 200
              },
              {
                Header: 'Fax',
                id: 'fax',
                accessor: 'fax',
                width: 200
              },
              //{
              //  Header: 'Clinic Manager Name & Phone',
              //  Cell: (row) => (row.original.team.map((el, i) => (
              //    <dl key={i}>
              //      <dd>{`${el.firstName} ${el.lastName} ${el.workPhone ? ' Phone: ' + el.workPhone : el.mobilePhone ? ' Mobile: ' + el.mobilePhone : ''}`}</dd>
              //    </dl>
              //  )))
              //},
            ]}
            defaultPageSize={this.state.pageSize}
            onPageSizeChange={(pageSize) =>
              this.setState({ pageSize })
            }
            onPageChange={(page) => this.setState({ page })}
            //filterable
            className="-striped -highlight"
            showPaginationTop={true}
            PaginationComponent={Pagination}
            onSearchChange={this.handleSearch}
          />
        )}
        <WidgetGrid>
          <div className="row">
            {(superMode || isClinicalStaff) && (
              <article className="col-md-12">
                <ClinicActivityStats
                  data={this.props.dashboard.data}
                  isLoading={this.props.dashboard.isLoading}
                />
              </article>
            )}
            {(superMode || isClinicalStaff) && (
              <article className="col-md-12">
                <DashboardMetrics
                  data={this.props.location.dataCount}
                  isLoading={this.props.dashboard.isLoading}
                />
              </article>
            )}
            {superMode && (
              <article className={superMode ? 'col-md-6' : 'col-md-12'}>
                <IMCScorecard
                  data={this.getMetricsData()}
                  isLoading={this.props.imc.isLoading}
                  fetchData={this.getMetrics}
                />
              </article>
            )}
            {superMode && (
              <article className="col-md-6">
                <ChartReviewQueueReport
                  searchUsers={this.searchUsers}
                  isSuperAdmin
                  data={this.props.dashboard.report}
                  isLoading={this.props.dashboard.isReportLoading}
                  onSubmit={this.formSubmit}
                />
              </article>
            )}
          </div>
        </WidgetGrid>

        {externalMode && (
          <div className="row">
            <div className='col-md-3'>
              <div className="panel panel-primary">
                <div className="panel-heading">User Profile</div>
                <div className="panel-body">
                  <h5>
                    <span className="semi-bold">Name: {userInfo.firstName} {userInfo.lastName}</span>
                    <br />
                    <span className="semi-bold">Role: {userInfo.roles.map(el => el.name).join()}</span>
                    <br />
                    <span className="semi-bold">Last Activity: <Moment
                      date={userInfo.lastActivity}
                      format="MM/DD/YYYY HH:mm"
                    />
                    </span>
                  </h5>
                  <hr className="simple" />
                  <p className="text-muted">
                    <i className="fa fa-envelope" />
                    &#xA0;&#xA0;
                    <a href={`mailto:${userInfo.email}`}> {userInfo.email} </a>
                  </p>
                </div>
              </div>
            </div>

            {userInfo.clients && userInfo.clients.map((l, idx) => (
              <div key={idx} className='col-md-3'>
                <div className="panel panel-primary">
                  <div className="panel-heading">{l.code} | {l.name}</div>
                  <div className="panel-body" id={l.code} >
                    <ClientInfo code={l.code} />
                  </div>
                </div>
              </div>
            ))}

          </div>
        )}

        {/*{this.state.showNPS && externalMode && (*/}
        {/*    <NPSInput onSubmit={this.NPSFormSubmit} />*/}
        {/*)}*/}
      </div>
    );
  }
}

export default connect(
  state => ({
    dashboard: state.dashboard,
    imc: state.imc,
    location: state.locationmanager,
    currentUser: state.currentUser,
    queryParams: state.currentUser.queryParams,
    locations: state.locations.list,
    isSuperAdmin: isSuperAdmin(state),
    isAdministrativeProvider: isAdministrativeProvider(state),
    isSupervisingPhysician: isSupervisingPhysician(state),
    isExternalStakeholder: isExternalStakeholder(state),
    isOrganizationalClient: isOrganizationalClient(state),
    isAdmin: isAdmin(state),
    isClinicalStaff: isClinicalStaff(state),
    isClinician: isClinician(state),
    isPhysiciansAssistant: isPhysiciansAssistant(state),
    isClinicalPharmacist: isClinicalPharmacist(state),
    isMakoAdmin: isMakoAdmin(state),
    isMakoUser: isMakoUser(state),
  }),
  dispatch => ({
    getUsersTypeahead: params => dispatch(requestUsersTypeahead(params)),
    getDashboardInfo: params => dispatch(requestDashboardInfo(params)),
    getIMCMetrics: params => dispatch(requestIMCMetrics(params)),
    getChartReviewQueueReport: params =>
      dispatch(requestChartReviewQueueReport(params)),
    submitNPSForm: (userID, params) => dispatch(submitNPSForm(userID, params)),
    getLocations: (params) => dispatch(requestLocationsDashboard(params)),
    getDashboardMetricsCount: (params) => dispatch(requestDashboardMetricsCount(params)),
  }),
)(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/dashboard/containers/Dashboard.js